import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import MarketplaceIcon from "@redotech/redo-icons/building-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { formatSentenceCase } from "@redotech/util/string";

const entry = fgFilterEntries.marketplaceNotificationStatus;

export const MarketplaceNotificationStatusArrayFilter: ArrayStringTableFilter<string> =
  {
    type: entry.type,
    Icon: MarketplaceIcon,
    operators: [...entry.operators],
    data: {
      name: entry.name,
      type: entry.type,
      value: [],
      operator: ArrayStringFilterOperator.ANY_OF,
    },
    itemLabel: "status",
    itemLabelPlural: "statuses",
    values: [...entry.staticValues],
    display: (item: string) => {
      return formatSentenceCase(item);
    },
    displayName: entry.displayName,
  };
